export default "__VITE_ASSET__Cj1sF1Wb__"